import React from "react";
import { Link } from "react-router-dom";

export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16 text-slate-700">
      <h1 className="font-display font-extrabold text-4xl text-slate-900">Privacy Policy</h1>
      <p className="text-sm text-slate-500 mt-2">Last updated: {new Date().toLocaleDateString("en-IN")}</p>

      <div className="prose prose-slate max-w-none mt-8 space-y-5 text-sm leading-relaxed">
        <p>
          At Repairro ("we", "us", "our"), we respect your privacy. This policy describes how we collect, use and protect your data when you use our website and services.
        </p>

        <h2 className="font-display font-bold text-xl text-slate-900 mt-6">Information we collect</h2>
        <ul className="list-disc pl-5 space-y-1">
          <li>Contact details (name, phone, email) when you book a service or apply as a technician.</li>
          <li>Service address and slot preferences to fulfil your booking.</li>
          <li>For technician applicants: identity and bank/UPI details required for onboarding & payouts.</li>
        </ul>

        <h2 className="font-display font-bold text-xl text-slate-900 mt-6">How we use it</h2>
        <ul className="list-disc pl-5 space-y-1">
          <li>To deliver the service you booked and contact you for scheduling.</li>
          <li>To verify technician identity and disburse payouts.</li>
          <li>To improve our services and send relevant service updates.</li>
        </ul>

        <h2 className="font-display font-bold text-xl text-slate-900 mt-6">Your rights</h2>
        <p>You can request deletion of your data at any time by contacting <Link to="/contact" className="text-[#FF6B2B] font-semibold">our support</Link>.</p>
      </div>
    </div>
  );
}
